import React, {Component} from 'react';
import {imageForExtension} from '../../services/format-images';
import './style.css';

export default class FileIcon extends Component{

    static defaultProps = {
        width: 100
    };

    onDelete = (e)=>{
        e.stopPropagation();
        this.props.onDelete( this.props.file );
    };

    render(){

        if( !this.props.file )
            return null;

        const parts = this.props.file.originalName.split('.');
        const image = imageForExtension( parts[ parts.length -1 ] );

        return(
            <div className="FileIcon"  style={{width: this.props.width + 30}} onClick={()=>this.props.onSelect( this.props.file )}>

                {this.props.onDelete?
                    <i className='fa fa-trash' onClick={this.onDelete} />
                    :null
                }

                {this.props.file.isFolder ?
                    (
                        this.props.cover?
                            <img className='folder-cover' alt={ this.props.file.originalName} src={this.props.cover}/>:
                            <i className='fa fa-folder' style={{width: this.props.width}} />
                    )
                    :
                    <img style={{width: this.props.width}} src={image}
                         alt={"File " + this.props.file.originalName + " icon"}/>
                }
                <p>{this.props.file.originalName}</p>
            </div>
        );
    }

}



// WEBPACK FOOTER //
// ./src/App/scenes/AppFrame/scenes/Files/components/FileIcon/index.js